/* istanbul ignore file */
/* tslint:disable */
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { makeResponses } from '../response_factory';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function webhook(config) {
    const deleteWebhookResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(config, () => Promise.resolve(null)),
    });
    return Object.freeze({
        /**
         * Deletes a specific webhook given its uuid.
         *
         * @param arg The arguments to the function.
         * @param arg.webhookId The id of the webhook to delete.
         * @returns Nothing.
         */
        deleteWebhook: async ({ webhookId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/webhooks/${webhookId}`, deleteWebhookResponse.v, undefined);
            return result;
        },
    });
}
